import React from 'react';
import { useSearchParams } from 'react-router-dom';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');

  .pat-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .pat-page { font-family: 'Inter', sans-serif; color: #0d1b3e; background: #ffffff; width: 100%; }

  /* ── Hero (Overview) ── */
  .pat-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .pat-hero-blob1 { position: absolute; top: -8%; right: -4%; width: 640px; height: 640px; border-radius: 50%; background: radial-gradient(circle, rgba(6,95,70,0.07), rgba(13,27,62,0.04)); filter: blur(90px); pointer-events: none; }
  .pat-hero-blob2 { position: absolute; bottom: -14%; left: -8%; width: 720px; height: 720px; border-radius: 50%; background: radial-gradient(circle, rgba(13,27,62,0.06), rgba(6,95,70,0.04)); filter: blur(90px); pointer-events: none; }
  .pat-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .pat-hero-inner { grid-template-columns: 1fr; } .pat-hero-card { display: none; } }

  .pat-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #f0fdf4; border: 1px solid #bbf7d0; font-size: 13px; font-weight: 500; color: #166534; margin-bottom: 28px; }
  .pat-badge-dot { width: 8px; height: 8px; border-radius: 50%; background: #16a34a; display: inline-block; animation: pat-pulse 2s ease-in-out infinite; }
  @keyframes pat-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(22,163,74,0.5); } 50% { box-shadow: 0 0 0 6px rgba(22,163,74,0); } }

  .pat-hero h1 { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(1.8rem, 3.375vw, 2.85rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; color: #0d1b3e; margin-bottom: 24px; }
  .pat-gradient-text { background: linear-gradient(135deg, #065f46 0%, #0d1b3e 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .pat-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 40px; }
  .pat-btn-group { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 44px; }
  .pat-btn-primary { padding: 14px 28px; background: #0d1b3e; color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .pat-btn-primary:hover { background: #065f46; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(6,95,70,0.3); }
  .pat-btn-secondary { padding: 14px 28px; background: #fff; color: #0d1b3e; border: 1.5px solid #cbd5e1; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .pat-btn-secondary:hover { border-color: #065f46; color: #064e3b; background: #f0fdf4; }
  .pat-trust-items { display: flex; gap: 24px; flex-wrap: wrap; }
  .pat-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #64748b; font-weight: 500; }
  .pat-trust-check { width: 20px; height: 20px; background: #dcfce7; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #16a34a; flex-shrink: 0; }

  /* Hero Card */
  .pat-hero-card { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,27,62,0.09), 0 4px 16px rgba(0,0,0,0.04); }
  .pat-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #f1f5f9; }
  .pat-card-title-label { font-size: 12px; color: #94a3b8; font-weight: 500; margin-bottom: 3px; }
  .pat-card-title-value { font-size: 15px; font-weight: 700; color: #0d1b3e; }
  .pat-card-badge { background: #f0fdf4; color: #166534; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 999px; border: 1px solid #bbf7d0; }
  .pat-status-item { display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border-radius: 10px; background: #f8fafc; border: 1px solid #f1f5f9; margin-bottom: 8px; }
  .pat-status-left { display: flex; align-items: center; gap: 10px; }
  .pat-status-icon { font-size: 16px; }
  .pat-status-name { font-size: 13px; font-weight: 600; color: #334155; }
  .pat-status-sub { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .pat-status-badge { font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 999px; white-space: nowrap; }
  .pat-badge-granted { background: #dcfce7; color: #166534; }
  .pat-badge-pending { background: #fef9c3; color: #854d0e; }
  .pat-badge-filed { background: #e0f2fe; color: #0369a1; }
  .pat-card-metric { margin-top: 14px; padding: 16px 18px; background: linear-gradient(135deg, #064e3b, #065f46); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; }
  .pat-metric-label { font-size: 11px; color: rgba(255,255,255,0.75); margin-bottom: 3px; }
  .pat-metric-value { font-size: 22px; font-weight: 800; color: #fff; }
  .pat-metric-badge { background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); border-radius: 999px; padding: 4px 12px; font-size: 11px; font-weight: 600; color: #fff; }

  /* ── Stats Bar ── */
  .pat-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .pat-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .pat-stats-grid { grid-template-columns: 1fr 1fr; } }
  .pat-stat-item { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .pat-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .pat-stat-item:nth-child(2n) { border-right: none; } .pat-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .pat-stat-num { font-family: 'Playfair Display', serif; font-size: 2.2rem; font-weight: 800; color: #065f46; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .pat-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ── Shared Layout ── */
  .pat-section { padding: 96px 24px; }
  .pat-container { max-width: 1200px; margin: 0 auto; }
  .pat-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .pat-section-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .pat-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.78; }
  .pat-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #065f46; margin-bottom: 12px; }

  /* ── Overview Service Cards ── */
  .pat-services-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .pat-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .pat-services-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .pat-services-grid { grid-template-columns: 1fr; } }
  .pat-svc-card { background: #fff; padding: 32px 28px; border-radius: 20px; border: 1px solid rgba(226,232,240,0.7); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; cursor: pointer; }
  .pat-svc-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); border-color: #bbf7d0; }
  .pat-svc-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; opacity: 0; transition: opacity 0.3s; border-radius: 20px 20px 0 0; background: linear-gradient(90deg, #065f46, #16a34a); }
  .pat-svc-card:hover::before { opacity: 1; }
  .pat-svc-icon { font-size: 28px; margin-bottom: 16px; }
  .pat-svc-title { font-size: 1rem; font-weight: 700; color: #0d1b3e; margin-bottom: 10px; }
  .pat-svc-desc { font-size: 0.88rem; color: #64748b; line-height: 1.72; margin-bottom: 14px; }
  .pat-svc-tag { font-size: 11.5px; font-weight: 600; color: #065f46; background: #f0fdf4; display: inline-block; padding: 3px 10px; border-radius: 999px; border: 1px solid #bbf7d0; }
  .pat-svc-arrow { font-size: 11px; font-weight: 700; color: #065f46; margin-left: 6px; opacity: 0; transition: opacity 0.2s; }
  .pat-svc-card:hover .pat-svc-arrow { opacity: 1; }

  /* ── Risks / Benefits ── */
  .pat-why-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: start; }
  @media (max-width: 900px) { .pat-why-grid { grid-template-columns: 1fr; gap: 48px; } }
  .pat-why-left h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 18px; }
  .pat-why-left p { font-size: 1rem; color: #64748b; line-height: 1.78; margin-bottom: 32px; }
  .pat-risk-items { display: flex; flex-direction: column; gap: 14px; }
  .pat-risk-item { display: flex; gap: 16px; padding: 16px 18px; background: #fff; border-radius: 14px; border: 1px solid #fecdd3; }
  .pat-risk-icon { width: 38px; height: 38px; border-radius: 10px; background: #fee2e2; display: flex; align-items: center; justify-content: center; font-size: 17px; flex-shrink: 0; }
  .pat-risk-title { font-size: 0.92rem; font-weight: 700; color: #991b1b; margin-bottom: 3px; }
  .pat-risk-desc { font-size: 0.84rem; color: #64748b; line-height: 1.6; }
  .pat-benefit-items { display: flex; flex-direction: column; gap: 18px; }
  .pat-benefit-item { display: flex; gap: 14px; padding: 16px 18px; background: #f0fdf4; border-radius: 14px; border: 1px solid #bbf7d0; }
  .pat-benefit-icon { width: 38px; height: 38px; border-radius: 10px; background: #dcfce7; display: flex; align-items: center; justify-content: center; font-size: 17px; flex-shrink: 0; }
  .pat-benefit-title { font-size: 0.92rem; font-weight: 700; color: #0d1b3e; margin-bottom: 3px; }
  .pat-benefit-desc { font-size: 0.84rem; color: #64748b; line-height: 1.6; }

  /* ── Process Steps ── */
  .pat-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .pat-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; position: relative; }
  @media (max-width: 900px) { .pat-process-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .pat-process-grid { grid-template-columns: 1fr; } }
  .pat-process-grid::before { content: ''; position: absolute; top: 27px; left: 12.5%; right: 12.5%; height: 2px; background: linear-gradient(90deg, #065f46, #16a34a); z-index: 0; }
  @media (max-width: 900px) { .pat-process-grid::before { display: none; } }
  .pat-process-step { text-align: center; position: relative; z-index: 1; }
  .pat-process-num { width: 56px; height: 56px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 4px solid #f8fafc; box-shadow: 0 0 0 2px #0d1b3e; }
  .pat-process-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 8px; }
  .pat-process-desc { font-size: 0.85rem; color: #64748b; line-height: 1.65; }

  /* ── CTA ── */
  .pat-cta { background: linear-gradient(135deg, #0d1b3e 0%, #064e3b 60%, #0d1b3e 100%); padding: 96px 24px; position: relative; overflow: hidden; }
  .pat-cta-blob1 { position: absolute; top: -80px; right: -60px; width: 380px; height: 380px; border-radius: 50%; background: rgba(134,239,172,0.07); filter: blur(60px); pointer-events: none; }
  .pat-cta-blob2 { position: absolute; bottom: -60px; left: -40px; width: 320px; height: 320px; border-radius: 50%; background: rgba(255,255,255,0.04); filter: blur(60px); pointer-events: none; }
  .pat-cta-inner { max-width: 720px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
  .pat-cta-tag { display: inline-block; background: rgba(134,239,172,0.14); border: 1px solid rgba(134,239,172,0.3); border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 700; color: #86efac; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 24px; }
  .pat-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: #fff; margin-bottom: 20px; line-height: 1.2; letter-spacing: -0.02em; }
  .pat-cta p { font-size: 1.1rem; color: rgba(255,255,255,0.78); line-height: 1.75; margin-bottom: 44px; }
  .pat-cta-btn-group { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; margin-bottom: 36px; }
  .pat-cta-btn-primary { padding: 16px 32px; background: #16a34a; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .pat-cta-btn-primary:hover { background: #15803d; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(22,163,74,0.4); }
  .pat-cta-btn-secondary { padding: 16px 32px; background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,0.35); border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .pat-cta-btn-secondary:hover { border-color: rgba(255,255,255,0.65); background: rgba(255,255,255,0.07); }
  .pat-cta-reassurances { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; }
  .pat-cta-reassurance { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(255,255,255,0.7); font-weight: 500; }
  .pat-cta-check { width: 18px; height: 18px; background: rgba(134,239,172,0.2); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 9px; color: #86efac; flex-shrink: 0; }

  /* ── Sub-page shared ── */
  .pat-back-btn { display: flex; width: fit-content; align-items: center; gap: 8px; padding: 7px 14px; border-radius: 999px; border: 1px solid #e2e8f0; background: #fff; color: #475569; font-size: 13px; font-weight: 600; cursor: pointer; margin-bottom: 28px; transition: all 0.15s; }
  .pat-back-btn:hover { background: #f0fdf4; border-color: #bbf7d0; color: #065f46; }
  .pat-sub-h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.6rem, 2.8vw, 2.3rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 16px; }

  /* Feature cards grid (2 or 3 col) */
  .pat-feat-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 900px) { .pat-feat-grid-3 { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 560px) { .pat-feat-grid-3 { grid-template-columns: 1fr; } }
  .pat-feat-grid-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
  @media (max-width: 680px) { .pat-feat-grid-2 { grid-template-columns: 1fr; } }
  .pat-feat-card { background: #fff; padding: 28px 24px; border-radius: 18px; border: 1px solid #e2e8f0; box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; }
  .pat-feat-card:hover { box-shadow: 0 12px 40px rgba(0,0,0,0.07); transform: translateY(-2px); }
  .pat-feat-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; background: linear-gradient(90deg, #065f46, #16a34a); border-radius: 18px 18px 0 0; }
  .pat-feat-card-icon { font-size: 26px; margin-bottom: 14px; }
  .pat-feat-card-title { font-size: 0.97rem; font-weight: 700; color: #0d1b3e; margin-bottom: 8px; }
  .pat-feat-card-desc { font-size: 0.87rem; color: #64748b; line-height: 1.7; }

  /* Two-column split layout for sub-pages */
  .pat-split { display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: start; }
  @media (max-width: 900px) { .pat-split { grid-template-columns: 1fr; gap: 48px; } }
  .pat-split-h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.6rem, 2.8vw, 2.2rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 16px; }
  .pat-split-p { font-size: 0.97rem; color: #64748b; line-height: 1.78; margin-bottom: 24px; }

  /* Vertical steps list */
  .pat-v-steps { display: flex; flex-direction: column; gap: 0; }
  .pat-v-step { display: flex; gap: 20px; position: relative; padding-bottom: 32px; }
  .pat-v-step:last-child { padding-bottom: 0; }
  .pat-v-step-left { display: flex; flex-direction: column; align-items: center; }
  .pat-v-step-num { width: 44px; height: 44px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 0.85rem; font-weight: 800; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .pat-v-step-line { width: 2px; flex: 1; background: #e2e8f0; margin-top: 8px; }
  .pat-v-step:last-child .pat-v-step-line { display: none; }
  .pat-v-step-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 6px; padding-top: 10px; }
  .pat-v-step-desc { font-size: 0.87rem; color: #64748b; line-height: 1.68; }

  /* Info highlight box */
  .pat-info-box { background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 16px; padding: 24px 28px; margin-bottom: 32px; }
  .pat-info-box-title { font-size: 0.92rem; font-weight: 700; color: #065f46; margin-bottom: 8px; }
  .pat-info-box-body { font-size: 0.88rem; color: #334155; line-height: 1.72; }

  /* Deliverable list */
  .pat-deliv-list { display: flex; flex-direction: column; gap: 12px; }
  .pat-deliv-item { display: flex; align-items: flex-start; gap: 12px; padding: 14px 18px; background: #f8fafc; border-radius: 12px; border: 1px solid #f1f5f9; }
  .pat-deliv-check { width: 22px; height: 22px; background: #dcfce7; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #16a34a; flex-shrink: 0; margin-top: 1px; }
  .pat-deliv-title { font-size: 0.9rem; font-weight: 700; color: #0d1b3e; margin-bottom: 3px; }
  .pat-deliv-desc { font-size: 0.83rem; color: #64748b; line-height: 1.6; }

  /* Type cards (for patent types, filing strategies etc.) */
  .pat-type-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
  @media (max-width: 600px) { .pat-type-grid { grid-template-columns: 1fr; } }
  .pat-type-card { padding: 22px 20px; border-radius: 16px; background: #fff; border: 1px solid #e2e8f0; border-top: 3px solid #065f46; }
  .pat-type-card-icon { font-size: 22px; margin-bottom: 10px; }
  .pat-type-card-title { font-size: 0.93rem; font-weight: 700; color: #0d1b3e; margin-bottom: 6px; }
  .pat-type-card-desc { font-size: 0.84rem; color: #64748b; line-height: 1.65; }
  .pat-type-card-tag { margin-top: 10px; font-size: 11px; font-weight: 600; color: #065f46; background: #f0fdf4; display: inline-block; padding: 2px 8px; border-radius: 999px; }

  /* Country / market grid */
  .pat-markets-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
  @media (max-width: 600px) { .pat-markets-grid { grid-template-columns: 1fr 1fr; } }
  .pat-market-item { display: flex; align-items: center; gap: 10px; padding: 12px 14px; background: #f8fafc; border-radius: 10px; border: 1px solid #f1f5f9; font-size: 0.88rem; font-weight: 600; color: #334155; }
  .pat-market-flag { font-size: 18px; }

  /* Timeline phases */
  .pat-timeline { display: flex; flex-direction: column; gap: 0; }
  .pat-timeline-item { display: flex; gap: 20px; padding-bottom: 28px; position: relative; }
  .pat-timeline-item:last-child { padding-bottom: 0; }
  .pat-timeline-dot { width: 14px; height: 14px; border-radius: 50%; background: #065f46; flex-shrink: 0; margin-top: 5px; position: relative; z-index: 1; }
  .pat-timeline-item::before { content: ''; position: absolute; left: 6px; top: 19px; bottom: 0; width: 2px; background: #e2e8f0; }
  .pat-timeline-item:last-child::before { display: none; }
  .pat-timeline-label { font-size: 11px; font-weight: 700; color: #065f46; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 4px; }
  .pat-timeline-title { font-size: 0.93rem; font-weight: 700; color: #0d1b3e; margin-bottom: 4px; }
  .pat-timeline-desc { font-size: 0.84rem; color: #64748b; line-height: 1.65; }

  /* Dark highlight band */
  .pat-dark-band { background: #0d1b3e; padding: 64px 24px; position: relative; overflow: hidden; }
  .pat-dark-band-inner { max-width: 1200px; margin: 0 auto; }
  .pat-dark-band h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.4rem); font-weight: 800; color: #fff; letter-spacing: -0.02em; margin-bottom: 16px; }
  .pat-dark-band p { font-size: 1rem; color: rgba(255,255,255,0.72); line-height: 1.75; max-width: 680px; }
  .pat-dark-band-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-top: 48px; }
  @media (max-width: 768px) { .pat-dark-band-grid { grid-template-columns: 1fr; } }
  .pat-dark-card { background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); border-radius: 16px; padding: 24px; }
  .pat-dark-card-icon { font-size: 22px; margin-bottom: 12px; }
  .pat-dark-card-title { font-size: 0.92rem; font-weight: 700; color: #fff; margin-bottom: 6px; }
  .pat-dark-card-desc { font-size: 0.84rem; color: rgba(255,255,255,0.65); line-height: 1.65; }
`;

/* ─────────────────────── Overview Data ─────────────────────── */

const patentStatuses = [
  { icon: "💡", name: "Utility Patent #7841", sub: "Granted · USPTO", badge: "Granted", badgeClass: "pat-badge-granted" },
  { icon: "🔬", name: "Method Patent #5523", sub: "Under examination", badge: "Pending", badgeClass: "pat-badge-pending" },
  { icon: "🎨", name: "Design Patent #2290", sub: "Application filed", badge: "Filed", badgeClass: "pat-badge-filed" },
  { icon: "🌍", name: "PCT International App", sub: "30 countries · Phase II", badge: "Pending", badgeClass: "pat-badge-pending" },
];

const overviewServices = [
  { icon: "🔍", title: "Patent Search & Prior Art Analysis", desc: "Comprehensive prior art searches across USPTO, EPO, and global databases to assess novelty before filing.", tag: "Foundation Step", slug: "patent-search" },
  { icon: "📝", title: "Patent Application Drafting", desc: "Expertly written utility, design, and provisional applications — strong claims, specs, and technical drawings.", tag: "Core Service", slug: "application-drafting" },
  { icon: "⚖️", title: "Patent Prosecution", desc: "Skilled handling of office actions, examiner interviews, and appeals — fighting for your patent at every stage.", tag: "Ongoing Representation", slug: "patent-prosecution" },
  { icon: "🌐", title: "International & PCT Filing", desc: "PCT applications and direct foreign filings in key markets — protecting your invention across borders.", tag: "Global Coverage", slug: "international-filing" },
  { icon: "🗂️", title: "IP Portfolio Management", desc: "Strategic oversight of your entire patent portfolio — maintenance, renewals, licensing, and gap analysis.", tag: "Long-Term Strategy", slug: "portfolio-management" },
  { icon: "🧭", title: "Innovation & IP Strategy", desc: "Custom IP roadmaps that align your patent pipeline with R&D investments and competitive positioning.", tag: "Strategic Advisory", slug: "innovation-strategy" },
];

const overviewRisks = [
  { icon: "😤", title: "Competitors Copy Your Innovation", desc: "Without a patent, rivals can legally reverse-engineer and sell your product — cutting into your market from day one." },
  { icon: "💸", title: "Lost Licensing Revenue", desc: "Unpatented inventions cannot be licensed. You forfeit royalty streams that could generate significant passive income." },
  { icon: "🚫", title: "No Legal Recourse", desc: "Without an issued patent, you have no standing to sue infringers or recover damages in federal court." },
];

const overviewBenefits = [
  { icon: "🏆", title: "Exclusive 20-Year Monopoly", desc: "A granted patent gives you the exclusive right to make, use, and sell your invention — legally blocking every competitor." },
  { icon: "💰", title: "Monetizable & Licensable Asset", desc: "Patents can be licensed, sold, or used as collateral — turning your R&D into a revenue-generating balance-sheet asset." },
  { icon: "🛡️", title: "Infringement Deterrence", desc: "Publicly registered patents signal serious IP protection — deterring would-be copycats before infringement begins." },
  { icon: "📈", title: "Higher Business Valuation", desc: "Investors and acquirers pay meaningful premiums for businesses with strong, defensible patent portfolios." },
];

/* ─────────────────────── Overview Page ─────────────────────── */

const PatentServicesOverview = ({ onSelect }: { onSelect: (slug: string) => void }) => (
  <>
    {/* Hero */}
    <section className="pat-hero">
      <div className="pat-hero-blob1" />
      <div className="pat-hero-blob2" />
      <div className="pat-hero-inner">
        <div>
          <div className="pat-badge"><span className="pat-badge-dot" />Patent Services</div>
          <h1>Turn Your Invention Into a <span className="pat-gradient-text">Protected Asset</span></h1>
          <p className="pat-hero-sub">
            From prior art search to granted patent, our registered patent attorneys guide you through
            every step — so your innovation is legally protected and commercially valuable.
          </p>
          <div className="pat-btn-group">
            <button className="pat-btn-primary">Start Patent Process →</button>
            <button className="pat-btn-secondary">Free Consultation</button>
          </div>
          <div className="pat-trust-items">
            {["Registered patent attorneys", "All technical fields", "USPTO & international filing", "Fixed-fee pricing available"].map((t, i) => (
              <div key={i} className="pat-trust-item"><span className="pat-trust-check">✓</span>{t}</div>
            ))}
          </div>
        </div>
        <div className="pat-hero-card">
          <div className="pat-card-header">
            <div><div className="pat-card-title-label">Active Portfolio</div><div className="pat-card-title-value">Patent Applications</div></div>
            <span className="pat-card-badge">4 Active</span>
          </div>
          {patentStatuses.map((item, i) => (
            <div key={i} className="pat-status-item">
              <div className="pat-status-left">
                <span className="pat-status-icon">{item.icon}</span>
                <div><div className="pat-status-name">{item.name}</div><div className="pat-status-sub">{item.sub}</div></div>
              </div>
              <span className={`pat-status-badge ${item.badgeClass}`}>{item.badge}</span>
            </div>
          ))}
          <div className="pat-card-metric">
            <div><div className="pat-metric-label">Estimated Patent Portfolio Value</div><div className="pat-metric-value">$1,240,000</div></div>
            <div className="pat-metric-badge">↑ Growing</div>
          </div>
        </div>
      </div>
    </section>

    {/* Stats */}
    <section className="pat-stats">
      <div className="pat-stats-grid">
        {[{ num: "1,800+", label: "Patents Filed" }, { num: "89%", label: "Grant Success Rate" }, { num: "25+", label: "Technical Fields" }, { num: "40+", label: "Countries Covered" }].map((s, i) => (
          <div key={i} className="pat-stat-item"><div className="pat-stat-num">{s.num}</div><div className="pat-stat-label">{s.label}</div></div>
        ))}
      </div>
    </section>

    {/* Services */}
    <section className="pat-section pat-services-bg">
      <div className="pat-container">
        <div className="pat-section-header">
          <div className="pat-kicker">Our Services</div>
          <h2>End-to-End Patent Protection</h2>
          <p>From the spark of an idea to a granted patent and beyond — click any service to learn what we offer and how it works.</p>
        </div>
        <div className="pat-services-grid">
          {overviewServices.map((svc, i) => (
            <div key={i} className="pat-svc-card" onClick={() => onSelect(svc.slug)}>
              <div className="pat-svc-icon">{svc.icon}</div>
              <div className="pat-svc-title">{svc.title} <span className="pat-svc-arrow">→</span></div>
              <div className="pat-svc-desc">{svc.desc}</div>
              <div className="pat-svc-tag">{svc.tag}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Risks vs Benefits */}
    <section className="pat-section">
      <div className="pat-container">
        <div className="pat-why-grid">
          <div className="pat-why-left">
            <div className="pat-kicker">The Cost of Waiting</div>
            <h2>What Happens to Unprotected Inventions</h2>
            <p>The USPTO is a first-to-file system. Every day without a patent is a day a competitor could file first — and there's no coming back from that.</p>
            <div className="pat-risk-items">
              {overviewRisks.map((r, i) => (
                <div key={i} className="pat-risk-item">
                  <div className="pat-risk-icon">{r.icon}</div>
                  <div><div className="pat-risk-title">{r.title}</div><div className="pat-risk-desc">{r.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="pat-kicker">Why Patents Pay Off</div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(1.6rem, 2.5vw, 2.2rem)", fontWeight: 800, color: "#0d1b3e", letterSpacing: "-0.02em", lineHeight: 1.2, marginBottom: "32px" }}>
              The Strategic Value of a Strong Patent
            </h2>
            <div className="pat-benefit-items">
              {overviewBenefits.map((b, i) => (
                <div key={i} className="pat-benefit-item">
                  <div className="pat-benefit-icon">{b.icon}</div>
                  <div><div className="pat-benefit-title">{b.title}</div><div className="pat-benefit-desc">{b.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Process */}
    <section className="pat-section pat-process-bg">
      <div className="pat-container">
        <div className="pat-section-header">
          <div className="pat-kicker">How It Works</div>
          <h2>From Idea to Granted Patent in 4 Steps</h2>
          <p>Our structured process ensures no step is missed — from the initial search through prosecution and long-term portfolio maintenance.</p>
        </div>
        <div className="pat-process-grid">
          {[
            { num: "01", title: "Prior Art Search", desc: "We conduct a comprehensive patentability search to confirm your invention is novel and non-obvious." },
            { num: "02", title: "Application Drafting", desc: "Our attorneys draft strong claims and specifications tailored to maximize the scope of your protection." },
            { num: "03", title: "USPTO Prosecution", desc: "We respond to office actions, negotiate with examiners, and argue your case until allowance." },
            { num: "04", title: "Grant & Maintenance", desc: "We manage post-grant maintenance, renewals, and portfolio strategy for the life of your patent." },
          ].map((step, i) => (
            <div key={i} className="pat-process-step">
              <div className="pat-process-num">{step.num}</div>
              <div className="pat-process-title">{step.title}</div>
              <div className="pat-process-desc">{step.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="pat-cta">
      <div className="pat-cta-blob1" /><div className="pat-cta-blob2" />
      <div className="pat-cta-inner">
        <div className="pat-cta-tag">Free Patent Search Included</div>
        <h2>Your Innovation Deserves Protection</h2>
        <p>Don't let a competitor file before you. Our registered patent attorneys will assess your invention, run a prior art search, and outline a protection strategy — at no upfront cost.</p>
        <div className="pat-cta-btn-group">
          <button className="pat-cta-btn-primary">Start Patent Process</button>
          <button className="pat-cta-btn-secondary">Free Consultation</button>
        </div>
        <div className="pat-cta-reassurances">
          {["Free patent search", "Registered patent attorneys", "All technical fields", "Fixed-fee pricing available"].map((r, i) => (
            <div key={i} className="pat-cta-reassurance"><span className="pat-cta-check">✓</span>{r}</div>
          ))}
        </div>
      </div>
    </section>
  </>
);

/* ─────────────────────── Sub-Page CTA (reusable) ─────────────────────── */

const SubCTA = ({ tag, title, body, primary, secondary, bullets }: {
  tag: string; title: string; body: string; primary: string; secondary: string; bullets: string[];
}) => (
  <section className="pat-cta">
    <div className="pat-cta-blob1" /><div className="pat-cta-blob2" />
    <div className="pat-cta-inner">
      <div className="pat-cta-tag">{tag}</div>
      <h2>{title}</h2>
      <p>{body}</p>
      <div className="pat-cta-btn-group">
        <button className="pat-cta-btn-primary">{primary}</button>
        <button className="pat-cta-btn-secondary">{secondary}</button>
      </div>
      <div className="pat-cta-reassurances">
        {bullets.map((r, i) => <div key={i} className="pat-cta-reassurance"><span className="pat-cta-check">✓</span>{r}</div>)}
      </div>
    </div>
  </section>
);

/* ─────────────────────── 1. Patent Search & Prior Art ─────────────────────── */

const PatentSearchPage = ({ onBack }: { onBack: () => void }) => (
  <>
    <section className="pat-hero">
      <div className="pat-hero-blob1" /><div className="pat-hero-blob2" />
      <div className="pat-hero-inner">
        <div>
          <button className="pat-back-btn" onClick={onBack}>← Back to Patent Services</button>
          <div className="pat-badge"><span className="pat-badge-dot" />Patent Search & Prior Art Analysis</div>
          <h1>Know Your Odds <span className="pat-gradient-text">Before You File</span></h1>
          <p className="pat-hero-sub">
            A patent application is a significant investment. Before you spend time and money drafting a full application,
            our attorneys search every global database to determine whether your invention is truly novel — and whether
            it's worth pursuing.
          </p>
          <div className="pat-btn-group">
            <button className="pat-btn-primary">Order a Patent Search →</button>
            <button className="pat-btn-secondary">Free Consultation</button>
          </div>
          <div className="pat-trust-items">
            {["USPTO · EPO · WIPO databases", "Patentability opinion included", "72-hour express option", "Attorney-reviewed results"].map((t, i) => (
              <div key={i} className="pat-trust-item"><span className="pat-trust-check">✓</span>{t}</div>
            ))}
          </div>
        </div>
        <div className="pat-hero-card">
          <div className="pat-card-header">
            <div><div className="pat-card-title-label">Search Report</div><div className="pat-card-title-value">Patentability Analysis</div></div>
            <span className="pat-card-badge">Complete</span>
          </div>
          {[
            { icon: "📚", name: "USPTO Full-Text Search", sub: "12,000+ patents reviewed", badge: "Done", badgeClass: "pat-badge-granted" },
            { icon: "🇪🇺", name: "EPO Espacenet Search", sub: "European prior art", badge: "Done", badgeClass: "pat-badge-granted" },
            { icon: "🌐", name: "WIPO Global Search", sub: "PCT applications reviewed", badge: "Done", badgeClass: "pat-badge-granted" },
            { icon: "📄", name: "Patentability Opinion", sub: "Attorney analysis", badge: "Ready", badgeClass: "pat-badge-filed" },
          ].map((item, i) => (
            <div key={i} className="pat-status-item">
              <div className="pat-status-left">
                <span className="pat-status-icon">{item.icon}</span>
                <div><div className="pat-status-name">{item.name}</div><div className="pat-status-sub">{item.sub}</div></div>
              </div>
              <span className={`pat-status-badge ${item.badgeClass}`}>{item.badge}</span>
            </div>
          ))}
          <div className="pat-card-metric">
            <div><div className="pat-metric-label">Overall Patentability Assessment</div><div className="pat-metric-value">Strong</div></div>
            <div className="pat-metric-badge">Recommend Filing</div>
          </div>
        </div>
      </div>
    </section>

    <section className="pat-stats">
      <div className="pat-stats-grid">
        {[{ num: "50K+", label: "Databases Searched" }, { num: "72 hrs", label: "Express Turnaround" }, { num: "3", label: "Search Types Offered" }, { num: "98%", label: "Search Accuracy" }].map((s, i) => (
          <div key={i} className="pat-stat-item"><div className="pat-stat-num">{s.num}</div><div className="pat-stat-label">{s.label}</div></div>
        ))}
      </div>
    </section>

    <section className="pat-section pat-services-bg">
      <div className="pat-container">
        <div className="pat-section-header">
          <div className="pat-kicker">Search Types</div>
          <h2>Three Searches — Three Different Questions</h2>
          <p>Not all patent searches are the same. We offer three distinct types depending on what you need to know — and when you need to know it.</p>
        </div>
        <div className="pat-feat-grid-3">
          {[
            { icon: "🔍", title: "Novelty / Patentability Search", desc: "The standard pre-filing search. We search global databases to identify prior art that could block your patent and assess whether your invention is novel and non-obvious enough to pursue.", tag: "Pre-Filing · Recommended First Step" },
            { icon: "🚦", title: "Freedom-to-Operate (FTO) Search", desc: "Determines whether you can commercialize your product without infringing existing patents held by others — critical before product launch, fundraising, or entering a new market.", tag: "Pre-Launch · Risk Management" },
            { icon: "⚖️", title: "Validity / Invalidity Search", desc: "Used in litigation or licensing disputes to find prior art that could invalidate a competitor's patent — or to confirm the strength of your own issued patent when it comes under attack.", tag: "Litigation Support · IP Defense" },
          ].map((c, i) => (
            <div key={i} className="pat-feat-card">
              <div className="pat-feat-card-icon">{c.icon}</div>
              <div className="pat-feat-card-title">{c.title}</div>
              <div className="pat-feat-card-desc">{c.desc}</div>
              <div style={{ marginTop: 12, fontSize: 11, fontWeight: 600, color: "#065f46", background: "#f0fdf4", display: "inline-block", padding: "3px 10px", borderRadius: 999, border: "1px solid #bbf7d0" }}>{c.tag}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="pat-section">
      <div className="pat-container">
        <div className="pat-split">
          <div>
            <div className="pat-kicker">Our Process</div>
            <div className="pat-sub-h2">How We Conduct a Patent Search</div>
            <p className="pat-split-p">Our searches go beyond a simple keyword query. We use professional patent databases, structured search strategies, and attorney judgment to give you the most accurate patentability picture possible.</p>
            <div className="pat-v-steps">
              {[
                { num: "01", title: "Invention Disclosure", desc: "We start with a detailed questionnaire and consultation to understand the technical features, key differentiators, and scope of your invention." },
                { num: "02", title: "Database Search", desc: "Our team searches USPTO, EPO Espacenet, WIPO PatentScope, and non-patent literature using advanced classification codes, not just keywords." },
                { num: "03", title: "Prior Art Analysis", desc: "Each potentially relevant reference is reviewed for relevance, claim overlap, and impact on your invention's novelty and non-obviousness." },
                { num: "04", title: "Patentability Opinion", desc: "An attorney prepares a written opinion summarizing findings, rating patentability, and recommending a filing strategy — full application, provisional, or design patent." },
              ].map((step, i) => (
                <div key={i} className="pat-v-step">
                  <div className="pat-v-step-left"><div className="pat-v-step-num">{step.num}</div><div className="pat-v-step-line" /></div>
                  <div><div className="pat-v-step-title">{step.title}</div><div className="pat-v-step-desc">{step.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="pat-kicker">What You Receive</div>
            <div className="pat-sub-h2">Your Deliverables</div>
            <p className="pat-split-p">Every patent search engagement includes a comprehensive set of deliverables — not just a list of references, but an actionable legal opinion you can act on immediately.</p>
            <div className="pat-deliv-list">
              {[
                { title: "Prior Art Summary Report", desc: "A curated list of the most relevant patents and publications found during the search, with relevance annotations." },
                { title: "Patentability Opinion Letter", desc: "A formal attorney opinion on whether your invention meets the novelty and non-obviousness requirements for patentability." },
                { title: "Claim Differentiation Analysis", desc: "Guidance on how to distinguish your invention from the closest prior art — shaping your future claims strategy." },
                { title: "Filing Recommendation", desc: "A concrete recommendation: file a utility patent, provisional patent, design patent, or a combination strategy." },
                { title: "Follow-Up Consultation", desc: "A 30-minute attorney call to walk through the findings, answer your questions, and align on next steps." },
              ].map((d, i) => (
                <div key={i} className="pat-deliv-item">
                  <div className="pat-deliv-check">✓</div>
                  <div><div className="pat-deliv-title">{d.title}</div><div className="pat-deliv-desc">{d.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <SubCTA tag="Free Prior Art Search" title="Know Before You Invest in a Full Application" body="Order a patentability search before committing to a full patent application. Our attorneys will search the global prior art landscape and give you an honest, actionable opinion on your invention's chances." primary="Order Patent Search" secondary="Talk to an Attorney" bullets={["Attorney-reviewed opinion", "USPTO + EPO + WIPO coverage", "72-hour express option", "Filing recommendation included"]} />
  </>
);

/* ─────────────────────── 2. Patent Application Drafting ─────────────────────── */

const ApplicationDraftingPage = ({ onBack }: { onBack: () => void }) => (
  <>
    <section className="pat-hero">
      <div className="pat-hero-blob1" /><div className="pat-hero-blob2" />
      <div className="pat-hero-inner">
        <div>
          <button className="pat-back-btn" onClick={onBack}>← Back to Patent Services</button>
          <div className="pat-badge"><span className="pat-badge-dot" />Patent Application Drafting</div>
          <h1>Claims That <span className="pat-gradient-text">Stand Up to Any Examiner</span></h1>
          <p className="pat-hero-sub">
            A patent is only as strong as its claims. Our registered patent attorneys draft applications
            with broad, defensible claims and airtight specifications — maximizing the scope of protection
            you receive and the value of your patent as a business asset.
          </p>
          <div className="pat-btn-group">
            <button className="pat-btn-primary">Start Drafting →</button>
            <button className="pat-btn-secondary">Free Consultation</button>
          </div>
          <div className="pat-trust-items">
            {["Utility, design & provisional patents", "Technical drawings included", "Claims strategy consultation", "Fixed-fee drafting available"].map((t, i) => (
              <div key={i} className="pat-trust-item"><span className="pat-trust-check">✓</span>{t}</div>
            ))}
          </div>
        </div>
        <div className="pat-hero-card">
          <div className="pat-card-header">
            <div><div className="pat-card-title-label">Application Status</div><div className="pat-card-title-value">Utility Patent Draft</div></div>
            <span className="pat-card-badge">In Progress</span>
          </div>
          {[
            { icon: "📋", name: "Claims (Independent + Dependent)", sub: "18 claims drafted", badge: "Done", badgeClass: "pat-badge-granted" },
            { icon: "📐", name: "Technical Drawings", sub: "12 figures prepared", badge: "Done", badgeClass: "pat-badge-granted" },
            { icon: "📄", name: "Specification & Abstract", sub: "Attorney review", badge: "Review", badgeClass: "pat-badge-pending" },
            { icon: "✍️", name: "Client Sign-Off", sub: "Awaiting approval", badge: "Pending", badgeClass: "pat-badge-filed" },
          ].map((item, i) => (
            <div key={i} className="pat-status-item">
              <div className="pat-status-left">
                <span className="pat-status-icon">{item.icon}</span>
                <div><div className="pat-status-name">{item.name}</div><div className="pat-status-sub">{item.sub}</div></div>
              </div>
              <span className={`pat-status-badge ${item.badgeClass}`}>{item.badge}</span>
            </div>
          ))}
          <div className="pat-card-metric">
            <div><div className="pat-metric-label">Estimated Filing Date</div><div className="pat-metric-value">Apr 2025</div></div>
            <div className="pat-metric-badge">On Schedule</div>
          </div>
        </div>
      </div>
    </section>

    <section className="pat-stats">
      <div className="pat-stats-grid">
        {[{ num: "1,800+", label: "Applications Drafted" }, { num: "89%", label: "Allowance Rate" }, { num: "4", label: "Patent Types Covered" }, { num: "25+", label: "Technical Fields" }].map((s, i) => (
          <div key={i} className="pat-stat-item"><div className="pat-stat-num">{s.num}</div><div className="pat-stat-label">{s.label}</div></div>
        ))}
      </div>
    </section>

    <section className="pat-section pat-services-bg">
      <div className="pat-container">
        <div className="pat-section-header">
          <div className="pat-kicker">Patent Types</div>
          <h2>We Draft Every Type of Patent Application</h2>
          <p>Different inventions call for different types of protection. Our attorneys recommend the right type — and often a combination — based on your invention and business goals.</p>
        </div>
        <div className="pat-type-grid">
          {[
            { icon: "⚙️", title: "Utility Patent", desc: "The most common and valuable patent type. Protects how something works, how it's made, or how it's used. 20-year term from filing date. Ideal for most inventions.", tag: "Most Common · 20-Year Term" },
            { icon: "🎨", title: "Design Patent", desc: "Protects the unique ornamental appearance of a product — not its function. Faster to obtain than utility patents and harder for competitors to design around.", tag: "Visual Protection · 15-Year Term" },
            { icon: "📋", title: "Provisional Patent Application", desc: "A lower-cost, 12-month placeholder that establishes your priority date while you refine your invention and assess commercial viability. Does not itself become a patent.", tag: "Priority Date · 12-Month Window" },
            { icon: "🌿", title: "Plant Patent", desc: "Protects new and distinct varieties of asexually reproduced plants, including hybrids. Niche but important for agricultural biotech and horticulture businesses.", tag: "Agricultural / Biotech" },
          ].map((c, i) => (
            <div key={i} className="pat-type-card">
              <div className="pat-type-card-icon">{c.icon}</div>
              <div className="pat-type-card-title">{c.title}</div>
              <div className="pat-type-card-desc">{c.desc}</div>
              <div className="pat-type-card-tag">{c.tag}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="pat-section">
      <div className="pat-container">
        <div className="pat-split">
          <div>
            <div className="pat-kicker">What Makes Strong Claims</div>
            <div className="pat-sub-h2">The Anatomy of a Well-Drafted Patent</div>
            <p className="pat-split-p">The difference between a patent that gets granted and one that gets rejected — or between a patent that blocks competitors and one that's easy to design around — comes down to drafting quality.</p>
            <div className="pat-info-box">
              <div className="pat-info-box-title">⚖️ Broad vs. Narrow Claims</div>
              <div className="pat-info-box-body">Independent claims should be as broad as the prior art allows — capturing the widest possible scope. Dependent claims add specificity as fallback positions. Our attorneys strategically layer both to create maximum protection with built-in fallbacks.</div>
            </div>
            <div className="pat-v-steps">
              {[
                { num: "01", title: "Invention Disclosure Meeting", desc: "We work with you to capture every technical aspect of your invention — including variations, embodiments, and potential workarounds competitors might attempt." },
                { num: "02", title: "Claims Strategy", desc: "Before drafting begins, we define the scope of your independent claims — deciding how broadly or narrowly to position your invention relative to the prior art." },
                { num: "03", title: "Full Application Drafting", desc: "We draft the complete specification, abstract, detailed description, and a full set of claims — utility, dependent, and method claims as appropriate." },
                { num: "04", title: "Drawings & Client Review", desc: "Professional technical drawings are prepared, and you review the full application before filing. We iterate until you're completely satisfied." },
              ].map((step, i) => (
                <div key={i} className="pat-v-step">
                  <div className="pat-v-step-left"><div className="pat-v-step-num">{step.num}</div><div className="pat-v-step-line" /></div>
                  <div><div className="pat-v-step-title">{step.title}</div><div className="pat-v-step-desc">{step.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="pat-kicker">Deliverables</div>
            <div className="pat-sub-h2">What You Receive</div>
            <p className="pat-split-p">Every application drafting engagement delivers a complete, filing-ready patent application — plus everything you need to understand and manage your IP going forward.</p>
            <div className="pat-deliv-list">
              {[
                { title: "Complete Patent Application", desc: "Full specification, abstract, claims set (independent + dependent), and detailed description of preferred embodiments." },
                { title: "Professional Patent Drawings", desc: "USPTO-compliant technical drawings or design views illustrating every claimed aspect of your invention." },
                { title: "Claims Strategy Memo", desc: "A written explanation of your claims architecture — why we drafted them as we did, and how to expand or defend them in prosecution." },
                { title: "Filing Confirmation & Receipt", desc: "Official USPTO filing confirmation with your application serial number, filing date, and examiner assignment details." },
                { title: "Prosecution Management", desc: "We track your application and proactively manage deadlines, office action windows, and examiner communications post-filing." },
              ].map((d, i) => (
                <div key={i} className="pat-deliv-item">
                  <div className="pat-deliv-check">✓</div>
                  <div><div className="pat-deliv-title">{d.title}</div><div className="pat-deliv-desc">{d.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <SubCTA tag="Drafting Starting From $2,500" title="Get an Application That Actually Holds Up" body="Poorly drafted patents can be invalid, narrow, or easy to design around. Our attorneys draft applications built to withstand USPTO scrutiny and competitor challenges — giving you the broadest, most defensible protection possible." primary="Start Patent Drafting" secondary="Free Consultation" bullets={["All patent types", "Technical drawings included", "Fixed-fee options", "Claims strategy included"]} />
  </>
);

/* ─────────────────────── 3. Patent Prosecution ─────────────────────── */

const PatentProsecutionPage = ({ onBack }: { onBack: () => void }) => (
  <>
    <section className="pat-hero">
      <div className="pat-hero-blob1" /><div className="pat-hero-blob2" />
      <div className="pat-hero-inner">
        <div>
          <button className="pat-back-btn" onClick={onBack}>← Back to Patent Services</button>
          <div className="pat-badge"><span className="pat-badge-dot" />Patent Prosecution</div>
          <h1>We Fight Until <span className="pat-gradient-text">You Get Your Patent</span></h1>
          <p className="pat-hero-sub">
            Most patent applications receive at least one office action before allowance. Our experienced patent
            attorneys respond strategically — arguing the merits, negotiating with examiners, and appealing
            when necessary — until your patent is granted.
          </p>
          <div className="pat-btn-group">
            <button className="pat-btn-primary">Get Prosecution Help →</button>
            <button className="pat-btn-secondary">Review My Application</button>
          </div>
          <div className="pat-trust-items">
            {["89% allowance rate", "Office action responses", "Examiner interviews", "Appeals & reexamination"].map((t, i) => (
              <div key={i} className="pat-trust-item"><span className="pat-trust-check">✓</span>{t}</div>
            ))}
          </div>
        </div>
        <div className="pat-hero-card">
          <div className="pat-card-header">
            <div><div className="pat-card-title-label">Prosecution Status</div><div className="pat-card-title-value">Application #16/842,771</div></div>
            <span className="pat-card-badge">Active</span>
          </div>
          {[
            { icon: "📬", name: "Office Action Received", sub: "Obviousness rejection · 35 USC §103", badge: "Received", badgeClass: "pat-badge-pending" },
            { icon: "📝", name: "Response Drafted", sub: "Arguments + claim amendments", badge: "In Draft", badgeClass: "pat-badge-filed" },
            { icon: "🤝", name: "Examiner Interview", sub: "Scheduled · Apr 18, 2025", badge: "Upcoming", badgeClass: "pat-badge-filed" },
            { icon: "✅", name: "Notice of Allowance", sub: "Target outcome", badge: "Pending", badgeClass: "pat-badge-pending" },
          ].map((item, i) => (
            <div key={i} className="pat-status-item">
              <div className="pat-status-left">
                <span className="pat-status-icon">{item.icon}</span>
                <div><div className="pat-status-name">{item.name}</div><div className="pat-status-sub">{item.sub}</div></div>
              </div>
              <span className={`pat-status-badge ${item.badgeClass}`}>{item.badge}</span>
            </div>
          ))}
          <div className="pat-card-metric">
            <div><div className="pat-metric-label">Firm Allowance Rate</div><div className="pat-metric-value">89%</div></div>
            <div className="pat-metric-badge">Above Industry Average</div>
          </div>
        </div>
      </div>
    </section>

    <section className="pat-stats">
      <div className="pat-stats-grid">
        {[{ num: "89%", label: "Allowance Rate" }, { num: "340+", label: "Office Actions Handled / Year" }, { num: "2.3", label: "Avg. Responses to Allowance" }, { num: "15+", label: "Examiner Interviews / Year" }].map((s, i) => (
          <div key={i} className="pat-stat-item"><div className="pat-stat-num">{s.num}</div><div className="pat-stat-label">{s.label}</div></div>
        ))}
      </div>
    </section>

    <section className="pat-section pat-services-bg">
      <div className="pat-container">
        <div className="pat-section-header">
          <div className="pat-kicker">Types of Office Actions</div>
          <h2>What Examiners Reject — and How We Respond</h2>
          <p>Understanding what type of rejection you're facing is the first step to overcoming it. Our attorneys have handled every type of office action the USPTO issues.</p>
        </div>
        <div className="pat-feat-grid-3">
          {[
            { icon: "🔗", title: "Obviousness Rejection (§103)", desc: "The most common rejection. The examiner combines existing references to argue your invention would have been obvious to someone skilled in the field. We argue why the combination is improper and why your invention involves an inventive step.", tag: "Most Common Rejection" },
            { icon: "📰", title: "Anticipation Rejection (§102)", desc: "The examiner claims a single prior art reference discloses every element of your claim. We analyze the reference closely, identify missing elements, and amend claims or argue distinctions that the examiner overlooked.", tag: "Novelty Challenge" },
            { icon: "📝", title: "Indefiniteness (§112)", desc: "The examiner argues your claims are unclear or lack sufficient written description. We respond with clarifying amendments and detailed arguments tying every claim limitation to the specification as filed.", tag: "Claim Clarity Issue" },
          ].map((c, i) => (
            <div key={i} className="pat-feat-card">
              <div className="pat-feat-card-icon">{c.icon}</div>
              <div className="pat-feat-card-title">{c.title}</div>
              <div className="pat-feat-card-desc">{c.desc}</div>
              <div style={{ marginTop: 12, fontSize: 11, fontWeight: 600, color: "#065f46", background: "#f0fdf4", display: "inline-block", padding: "3px 10px", borderRadius: 999, border: "1px solid #bbf7d0" }}>{c.tag}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="pat-section">
      <div className="pat-container">
        <div className="pat-split">
          <div>
            <div className="pat-kicker">Our Prosecution Strategy</div>
            <div className="pat-sub-h2">How We Approach Every Office Action</div>
            <p className="pat-split-p">A great office action response is part legal argument, part negotiation, and part strategy. We don't just respond to what the examiner said — we position your application for the broadest possible allowance.</p>
            <div className="pat-v-steps">
              {[
                { num: "01", title: "Rejection Analysis", desc: "We analyze every rejection in the office action in detail — identifying the examiner's reasoning, the references cited, and the specific claim elements they're targeting." },
                { num: "02", title: "Response Strategy", desc: "We recommend a strategy: argue without amendments (if the rejection is weak), amend claims narrowly (to overcome prior art while preserving value), or both." },
                { num: "03", title: "Examiner Interview", desc: "When appropriate, we request a direct interview with the patent examiner — often the fastest path to allowance, as it allows real-time negotiation of claim language." },
                { num: "04", title: "Appeal if Necessary", desc: "If the examiner issues a final rejection that we believe is legally incorrect, we file an appeal to the Patent Trial and Appeal Board (PTAB) and argue your case before a panel of judges." },
              ].map((step, i) => (
                <div key={i} className="pat-v-step">
                  <div className="pat-v-step-left"><div className="pat-v-step-num">{step.num}</div><div className="pat-v-step-line" /></div>
                  <div><div className="pat-v-step-title">{step.title}</div><div className="pat-v-step-desc">{step.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="pat-kicker">Full Prosecution Coverage</div>
            <div className="pat-sub-h2">Every Stage of the USPTO Process</div>
            <p className="pat-split-p">Patent prosecution doesn't end at the first office action. We manage the entire prosecution lifecycle — from filing through grant, and post-grant if needed.</p>
            <div className="pat-deliv-list">
              {[
                { title: "First Office Action Response", desc: "Comprehensive written response to the examiner's first rejection — arguments, claim amendments, and supporting case law." },
                { title: "Final Office Action Response", desc: "After a final rejection, we file a response after final (RAF), a Request for Continued Examination (RCE), or an appeal — whichever gives you the best path forward." },
                { title: "Examiner Interviews", desc: "Pre-scheduled telephone interviews with the examiner to negotiate claim language and accelerate allowance." },
                { title: "PTAB Appeals", desc: "If prosecution fails at the examiner level, we appeal to the Patent Trial and Appeal Board with full briefing and oral argument." },
                { title: "Post-Grant Proceedings", desc: "Defense against inter partes review (IPR), post-grant review (PGR), and ex parte reexamination — protecting your granted patent from validity challenges." },
              ].map((d, i) => (
                <div key={i} className="pat-deliv-item">
                  <div className="pat-deliv-check">✓</div>
                  <div><div className="pat-deliv-title">{d.title}</div><div className="pat-deliv-desc">{d.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <SubCTA tag="89% Allowance Rate" title="Don't Let a Rejection End Your Patent Journey" body="Most first office actions are not the end — they're the beginning of a negotiation. Our patent attorneys know how to argue, amend, and negotiate your way to a granted patent." primary="Get Prosecution Help" secondary="Review My Application" bullets={["Office action responses", "Examiner interviews", "PTAB appeals", "Post-grant defense"]} />
  </>
);

/* ─────────────────────── 4. International & PCT Filing ─────────────────────── */

const InternationalFilingPage = ({ onBack }: { onBack: () => void }) => (
  <>
    <section className="pat-hero">
      <div className="pat-hero-blob1" /><div className="pat-hero-blob2" />
      <div className="pat-hero-inner">
        <div>
          <button className="pat-back-btn" onClick={onBack}>← Back to Patent Services</button>
          <div className="pat-badge"><span className="pat-badge-dot" />International & PCT Filing</div>
          <h1>Protect Your Invention <span className="pat-gradient-text">in Every Market That Matters</span></h1>
          <p className="pat-hero-sub">
            If your product will be manufactured, sold, or licensed in multiple countries, you need international patent
            protection. We handle PCT applications, national phase entries, and direct foreign filings — managing the
            entire global process so you can focus on your business.
          </p>
          <div className="pat-btn-group">
            <button className="pat-btn-primary">Start International Filing →</button>
            <button className="pat-btn-secondary">Free Strategy Call</button>
          </div>
          <div className="pat-trust-items">
            {["PCT + direct foreign filing", "40+ countries covered", "National phase management", "Cost optimization strategy"].map((t, i) => (
              <div key={i} className="pat-trust-item"><span className="pat-trust-check">✓</span>{t}</div>
            ))}
          </div>
        </div>
        <div className="pat-hero-card">
          <div className="pat-card-header">
            <div><div className="pat-card-title-label">Global Filing</div><div className="pat-card-title-value">PCT Application Status</div></div>
            <span className="pat-card-badge">Phase II</span>
          </div>
          {[
            { icon: "🇺🇸", name: "Priority Date Filed (US)", sub: "Application #18/221,408", badge: "Done", badgeClass: "pat-badge-granted" },
            { icon: "🌐", name: "PCT Application Filed", sub: "WIPO · 30 countries", badge: "Filed", badgeClass: "pat-badge-granted" },
            { icon: "🇪🇺", name: "European Phase Entry", sub: "EPO national phase", badge: "Active", badgeClass: "pat-badge-filed" },
            { icon: "🇯🇵", name: "Japan National Phase", sub: "JPO entry pending", badge: "Pending", badgeClass: "pat-badge-pending" },
          ].map((item, i) => (
            <div key={i} className="pat-status-item">
              <div className="pat-status-left">
                <span className="pat-status-icon">{item.icon}</span>
                <div><div className="pat-status-name">{item.name}</div><div className="pat-status-sub">{item.sub}</div></div>
              </div>
              <span className={`pat-status-badge ${item.badgeClass}`}>{item.badge}</span>
            </div>
          ))}
          <div className="pat-card-metric">
            <div><div className="pat-metric-label">Countries Under Protection</div><div className="pat-metric-value">30 Active</div></div>
            <div className="pat-metric-badge">Global Coverage</div>
          </div>
        </div>
      </div>
    </section>

    <section className="pat-stats">
      <div className="pat-stats-grid">
        {[{ num: "40+", label: "Countries Covered" }, { num: "90+", label: "PCT Filings / Year" }, { num: "30", label: "PCT Member States via Single App" }, { num: "18 mo", label: "International Phase Window" }].map((s, i) => (
          <div key={i} className="pat-stat-item"><div className="pat-stat-num">{s.num}</div><div className="pat-stat-label">{s.label}</div></div>
        ))}
      </div>
    </section>

    <section className="pat-section pat-services-bg">
      <div className="pat-container">
        <div className="pat-section-header">
          <div className="pat-kicker">Filing Strategies</div>
          <h2>Two Routes to International Protection</h2>
          <p>There is no single "international patent." Instead, you file strategically through one or both of these routes depending on your timeline, budget, and target markets.</p>
        </div>
        <div className="pat-feat-grid-2">
          {[
            { icon: "🌐", title: "PCT (Patent Cooperation Treaty) — International Application", desc: "A single PCT application preserves your rights in 150+ member countries for up to 30 months from your priority date — buying you time to evaluate markets and funding before committing to expensive national phase filings. It does not itself result in a granted patent, but gives you the option to pursue protection in every PCT member state.", tag: "Best for: Multiple markets · Fundraising runway · Early-stage companies" },
            { icon: "📌", title: "Direct National / Regional Filing", desc: "Filing directly in individual countries (or through regional bodies like the EPO for Europe) is faster but requires separate filings and translations upfront. Best when you know exactly which markets matter and want to bypass the PCT timeline — often used for China, Canada, or countries where speed to grant is critical.", tag: "Best for: Known markets · Faster grant · Post-PCT national phase" },
          ].map((c, i) => (
            <div key={i} className="pat-feat-card">
              <div className="pat-feat-card-icon">{c.icon}</div>
              <div className="pat-feat-card-title">{c.title}</div>
              <div className="pat-feat-card-desc">{c.desc}</div>
              <div style={{ marginTop: 12, fontSize: 11, fontWeight: 600, color: "#065f46", background: "#f0fdf4", display: "inline-block", padding: "3px 10px", borderRadius: 999, border: "1px solid #bbf7d0" }}>{c.tag}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="pat-section">
      <div className="pat-container">
        <div className="pat-split">
          <div>
            <div className="pat-kicker">Key Markets We Cover</div>
            <div className="pat-sub-h2">Global Protection in the Markets That Matter Most</div>
            <p className="pat-split-p">We file and manage national phase entries across all major global markets — coordinating with our network of local patent attorneys where required.</p>
            <div className="pat-markets-grid">
              {[
                { flag: "🇺🇸", name: "United States" }, { flag: "🇪🇺", name: "European Union" }, { flag: "🇨🇳", name: "China" },
                { flag: "🇯🇵", name: "Japan" }, { flag: "🇰🇷", name: "South Korea" }, { flag: "🇬🇧", name: "United Kingdom" },
                { flag: "🇨🇦", name: "Canada" }, { flag: "🇦🇺", name: "Australia" }, { flag: "🇮🇳", name: "India" },
                { flag: "🇧🇷", name: "Brazil" }, { flag: "🇸🇬", name: "Singapore" }, { flag: "🇮🇱", name: "Israel" },
              ].map((m, i) => (
                <div key={i} className="pat-market-item"><span className="pat-market-flag">{m.flag}</span>{m.name}</div>
              ))}
            </div>
          </div>
          <div>
            <div className="pat-kicker">PCT Timeline</div>
            <div className="pat-sub-h2">The International Patent Journey</div>
            <p className="pat-split-p">Understanding the PCT timeline helps you plan your market entry strategy and budget international filing costs appropriately.</p>
            <div className="pat-timeline">
              {[
                { label: "Month 0", title: "Priority Application Filed (US)", desc: "Your US provisional or non-provisional establishes the priority date. All future international applications will claim this date." },
                { label: "Month 12", title: "PCT Application Filed", desc: "File the PCT application within 12 months of your priority date. This preserves your rights in 150+ countries with a single filing." },
                { label: "Months 16–18", title: "International Search Report", desc: "WIPO issues an International Search Report (ISR) identifying prior art — useful for assessing patentability before national phase costs." },
                { label: "Month 18", title: "International Publication", desc: "Your application is published by WIPO, creating a public record and prior art date against future filers." },
                { label: "Month 30", title: "National Phase Entry Deadline", desc: "You must enter the national/regional phase in each target country. This is when individual country fees and translations become due." },
              ].map((t, i) => (
                <div key={i} className="pat-timeline-item">
                  <div className="pat-timeline-dot" />
                  <div>
                    <div className="pat-timeline-label">{t.label}</div>
                    <div className="pat-timeline-title">{t.title}</div>
                    <div className="pat-timeline-desc">{t.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <SubCTA tag="Global Patent Strategy" title="Protect Your Invention Where Your Competitors Are" body="International patent protection starts with a single priority date. Our attorneys will build a filing strategy that covers your most important markets efficiently — maximizing protection while managing costs." primary="Start International Filing" secondary="Free Strategy Call" bullets={["40+ countries", "PCT + direct filing", "National phase management", "Translation coordination"]} />
  </>
);

/* ─────────────────────── 5. IP Portfolio Management ─────────────────────── */

const PortfolioManagementPage = ({ onBack }: { onBack: () => void }) => (
  <>
    <section className="pat-hero">
      <div className="pat-hero-blob1" /><div className="pat-hero-blob2" />
      <div className="pat-hero-inner">
        <div>
          <button className="pat-back-btn" onClick={onBack}>← Back to Patent Services</button>
          <div className="pat-badge"><span className="pat-badge-dot" />IP Portfolio Management</div>
          <h1>Your IP Portfolio Is a <span className="pat-gradient-text">Business Asset — Manage It Like One</span></h1>
          <p className="pat-hero-sub">
            Most patent owners focus on filing — and then forget about their IP. Our portfolio management service
            ensures every patent you hold is actively maintained, strategically positioned, and generating maximum
            value for your business.
          </p>
          <div className="pat-btn-group">
            <button className="pat-btn-primary">Get a Portfolio Review →</button>
            <button className="pat-btn-secondary">Free Consultation</button>
          </div>
          <div className="pat-trust-items">
            {["Maintenance fee management", "Portfolio audits & gap analysis", "Licensing strategy", "Renewal deadline tracking"].map((t, i) => (
              <div key={i} className="pat-trust-item"><span className="pat-trust-check">✓</span>{t}</div>
            ))}
          </div>
        </div>
        <div className="pat-hero-card">
          <div className="pat-card-header">
            <div><div className="pat-card-title-label">Portfolio Overview</div><div className="pat-card-title-value">Active IP Assets</div></div>
            <span className="pat-card-badge">12 Patents</span>
          </div>
          {[
            { icon: "✅", name: "7 Granted US Patents", sub: "Maintenance current", badge: "Active", badgeClass: "pat-badge-granted" },
            { icon: "⏳", name: "3 Pending Applications", sub: "In prosecution", badge: "Pending", badgeClass: "pat-badge-pending" },
            { icon: "🌍", name: "2 International Families", sub: "EPO + Japan", badge: "Filed", badgeClass: "pat-badge-filed" },
            { icon: "⚠️", name: "Next Maintenance Fee", sub: "Due in 47 days", badge: "Action Req.", badgeClass: "pat-badge-pending" },
          ].map((item, i) => (
            <div key={i} className="pat-status-item">
              <div className="pat-status-left">
                <span className="pat-status-icon">{item.icon}</span>
                <div><div className="pat-status-name">{item.name}</div><div className="pat-status-sub">{item.sub}</div></div>
              </div>
              <span className={`pat-status-badge ${item.badgeClass}`}>{item.badge}</span>
            </div>
          ))}
          <div className="pat-card-metric">
            <div><div className="pat-metric-label">Estimated Portfolio Value</div><div className="pat-metric-value">$3,800,000</div></div>
            <div className="pat-metric-badge">↑ +18% YoY</div>
          </div>
        </div>
      </div>
    </section>

    <section className="pat-stats">
      <div className="pat-stats-grid">
        {[{ num: "600+", label: "Portfolios Managed" }, { num: "$0", label: "Missed Maintenance Fees" }, { num: "3.4x", label: "Avg. Portfolio Value Growth" }, { num: "24/7", label: "Deadline Monitoring" }].map((s, i) => (
          <div key={i} className="pat-stat-item"><div className="pat-stat-num">{s.num}</div><div className="pat-stat-label">{s.label}</div></div>
        ))}
      </div>
    </section>

    <section className="pat-section pat-services-bg">
      <div className="pat-container">
        <div className="pat-section-header">
          <div className="pat-kicker">What We Manage</div>
          <h2>Complete Patent Portfolio Services</h2>
          <p>We handle every aspect of your patent portfolio — from the administrative to the strategic — so your IP always works as hard as your business does.</p>
        </div>
        <div className="pat-feat-grid-3">
          {[
            { icon: "🗓️", title: "Maintenance Fee Management", desc: "USPTO maintenance fees are due at 3.5, 7.5, and 11.5 years after grant. Missing a deadline means your patent expires permanently. We track every deadline and pay fees on time — automatically." },
            { icon: "🔍", title: "Portfolio Audits", desc: "A full review of every patent you hold — identifying which are strong, which are redundant, which should be abandoned to save costs, and where your IP coverage has dangerous gaps." },
            { icon: "💰", title: "Licensing Strategy", desc: "Identify licensing opportunities within your portfolio — matching your patents to potential licensees, structuring deal terms, and drafting license agreements that protect your rights." },
            { icon: "🛡️", title: "Infringement Monitoring", desc: "We monitor competitor products, published applications, and market activity to identify potential infringement early — before it becomes costly litigation." },
            { icon: "📈", title: "Portfolio Valuation", desc: "Professional IP valuation for fundraising, M&A due diligence, licensing negotiations, or estate planning — backed by defensible methodology and market comparables." },
            { icon: "🧭", title: "Strategic Filing Decisions", desc: "Guidance on which new inventions are worth patenting, which pending applications to continue vs. abandon, and how to allocate your IP budget for maximum competitive impact." },
          ].map((c, i) => (
            <div key={i} className="pat-feat-card">
              <div className="pat-feat-card-icon">{c.icon}</div>
              <div className="pat-feat-card-title">{c.title}</div>
              <div className="pat-feat-card-desc">{c.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="pat-section">
      <div className="pat-container">
        <div className="pat-split">
          <div>
            <div className="pat-kicker">Why It Matters</div>
            <div className="pat-sub-h2">What Happens When You Don't Manage Your Portfolio</div>
            <p className="pat-split-p">A neglected patent portfolio is a liability, not an asset. Most IP problems we fix for new clients could have been prevented with basic portfolio management.</p>
            <div className="pat-risk-items">
              {[
                { icon: "⚠️", title: "Patents Expire from Missed Fees", desc: "More than 20% of US patents lapse early due to missed maintenance fees. Once expired, your patent cannot be revived — and your invention becomes freely usable by anyone." },
                { icon: "🕳️", title: "Coverage Gaps Go Undetected", desc: "Competitors file around poorly managed portfolios, exploiting technology areas your patents don't actually cover — often because no one has reviewed the portfolio strategically in years." },
                { icon: "💸", title: "Money Wasted on Weak Patents", desc: "Many portfolios include granted patents that are commercially worthless — too narrow to block competitors or license. A portfolio audit identifies which patents deserve continued investment." },
              ].map((r, i) => (
                <div key={i} className="pat-risk-item">
                  <div className="pat-risk-icon">{r.icon}</div>
                  <div><div className="pat-risk-title">{r.title}</div><div className="pat-risk-desc">{r.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="pat-kicker">Our Process</div>
            <div className="pat-sub-h2">How We Take Over Your Portfolio</div>
            <p className="pat-split-p">Onboarding is straightforward. We take full responsibility for your patent portfolio within 48 hours of engagement — so nothing falls through the cracks during the transition.</p>
            <div className="pat-v-steps">
              {[
                { num: "01", title: "Portfolio Intake & Audit", desc: "We gather all your patent records, map every asset, and audit the portfolio for maintenance status, commercial value, and strategic coverage." },
                { num: "02", title: "Deadline & Fee Transfer", desc: "We take over all maintenance fee responsibilities and upload your portfolio into our deadline management system with automated alerts." },
                { num: "03", title: "Strategic Review Meeting", desc: "We present our audit findings — which patents to keep, which to abandon, where to file new applications, and how to position your portfolio for licensing or M&A." },
                { num: "04", title: "Ongoing Management", desc: "We provide quarterly portfolio reports, proactive strategic recommendations, and full-service administration for every patent in your portfolio." },
              ].map((step, i) => (
                <div key={i} className="pat-v-step">
                  <div className="pat-v-step-left"><div className="pat-v-step-num">{step.num}</div><div className="pat-v-step-line" /></div>
                  <div><div className="pat-v-step-title">{step.title}</div><div className="pat-v-step-desc">{step.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <SubCTA tag="Free Portfolio Audit" title="Find Out What Your IP Is Actually Worth" body="Get a free portfolio audit and discover which patents are working for you, which are wasting money, and what opportunities you're missing. We'll take over management and never miss a deadline." primary="Get Free Portfolio Audit" secondary="Free Consultation" bullets={["Free initial audit", "Maintenance fee takeover", "Licensing identification", "No missed deadlines — guaranteed"]} />
  </>
);

/* ─────────────────────── 6. Innovation & IP Strategy ─────────────────────── */

const InnovationStrategyPage = ({ onBack }: { onBack: () => void }) => (
  <>
    <section className="pat-hero">
      <div className="pat-hero-blob1" /><div className="pat-hero-blob2" />
      <div className="pat-hero-inner">
        <div>
          <button className="pat-back-btn" onClick={onBack}>← Back to Patent Services</button>
          <div className="pat-badge"><span className="pat-badge-dot" />Innovation & IP Strategy</div>
          <h1>Turn Your R&D Into a <span className="pat-gradient-text">Competitive Moat</span></h1>
          <p className="pat-hero-sub">
            Most companies patent reactively — filing when an attorney suggests it, not when the business demands it.
            Our IP strategy service builds a proactive, forward-looking patent roadmap that aligns your IP with your
            R&D investments, competitive landscape, and long-term growth goals.
          </p>
          <div className="pat-btn-group">
            <button className="pat-btn-primary">Build Your IP Strategy →</button>
            <button className="pat-btn-secondary">Free Strategy Call</button>
          </div>
          <div className="pat-trust-items">
            {["Patent landscape analysis", "R&D alignment", "Competitive moat building", "Investor-ready IP roadmaps"].map((t, i) => (
              <div key={i} className="pat-trust-item"><span className="pat-trust-check">✓</span>{t}</div>
            ))}
          </div>
        </div>
        <div className="pat-hero-card">
          <div className="pat-card-header">
            <div><div className="pat-card-title-label">IP Roadmap</div><div className="pat-card-title-value">3-Year Strategy</div></div>
            <span className="pat-card-badge">In Progress</span>
          </div>
          {[
            { icon: "🗺️", name: "Patent Landscape Analysis", sub: "Competitor IP mapped", badge: "Done", badgeClass: "pat-badge-granted" },
            { icon: "🎯", name: "Filing Priority Matrix", sub: "12 inventions scored", badge: "Done", badgeClass: "pat-badge-granted" },
            { icon: "📊", name: "R&D Alignment Workshop", sub: "Engineering team session", badge: "Scheduled", badgeClass: "pat-badge-filed" },
            { icon: "📋", name: "IP Roadmap Delivery", sub: "3-year filing plan", badge: "Pending", badgeClass: "pat-badge-pending" },
          ].map((item, i) => (
            <div key={i} className="pat-status-item">
              <div className="pat-status-left">
                <span className="pat-status-icon">{item.icon}</span>
                <div><div className="pat-status-name">{item.name}</div><div className="pat-status-sub">{item.sub}</div></div>
              </div>
              <span className={`pat-status-badge ${item.badgeClass}`}>{item.badge}</span>
            </div>
          ))}
          <div className="pat-card-metric">
            <div><div className="pat-metric-label">Projected Portfolio Value (3yr)</div><div className="pat-metric-value">$5,200,000</div></div>
            <div className="pat-metric-badge">↑ Strategic Growth</div>
          </div>
        </div>
      </div>
    </section>

    <section className="pat-stats">
      <div className="pat-stats-grid">
        {[{ num: "140+", label: "IP Strategies Delivered" }, { num: "3.8x", label: "Avg. Portfolio ROI" }, { num: "92%", label: "Clients Secured Funding" }, { num: "5+", label: "Industries Served" }].map((s, i) => (
          <div key={i} className="pat-stat-item"><div className="pat-stat-num">{s.num}</div><div className="pat-stat-label">{s.label}</div></div>
        ))}
      </div>
    </section>

    <section className="pat-section pat-services-bg">
      <div className="pat-container">
        <div className="pat-section-header">
          <div className="pat-kicker">Strategic Services</div>
          <h2>What an IP Strategy Engagement Covers</h2>
          <p>IP strategy is not a single deliverable — it's an ongoing discipline. Our strategic advisory practice covers everything from competitive intelligence to investor positioning.</p>
        </div>
        <div className="pat-feat-grid-3">
          {[
            { icon: "🗺️", title: "Patent Landscape Analysis", desc: "A comprehensive map of all relevant patents in your technology space — identifying who owns what, where the white spaces are, and where the competitive pressure is greatest. The foundation of any IP strategy." },
            { icon: "🎯", title: "Filing Priority Matrix", desc: "Not every invention is worth patenting. We score your pending inventions against commercial value, patentability, competitive threat, and licensing potential — so you invest your IP budget where it matters most." },
            { icon: "🏗️", title: "Patent Moat Architecture", desc: "We design a layered patent strategy — broad pioneer claims, improvement patents, design patents, and continuation strategies — that builds a fence around your core technology that competitors cannot easily climb." },
            { icon: "📐", title: "R&D Alignment Workshops", desc: "We work directly with your engineering and product teams to identify patentable innovations before they're disclosed publicly, and build IP capture into your development process from day one." },
            { icon: "💼", title: "Investor-Ready IP Positioning", desc: "We prepare IP summary memoranda, portfolio maps, and claim charts tailored for investor due diligence — helping you demonstrate the strength and defensibility of your IP to Series A, B, and growth-stage investors." },
            { icon: "🤝", title: "Licensing & Monetization Planning", desc: "Identify patents suitable for outbound licensing, develop licensing program structures, identify target licensees, and build the legal framework needed to generate royalty revenue from your IP portfolio." },
          ].map((c, i) => (
            <div key={i} className="pat-feat-card">
              <div className="pat-feat-card-icon">{c.icon}</div>
              <div className="pat-feat-card-title">{c.title}</div>
              <div className="pat-feat-card-desc">{c.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="pat-section">
      <div className="pat-container">
        <div className="pat-split">
          <div>
            <div className="pat-kicker">Who Needs This</div>
            <div className="pat-sub-h2">IP Strategy Is for Companies at Every Stage</div>
            <p className="pat-split-p">Whether you're a startup filing your first patent or a growth-stage company preparing for M&A, a deliberate IP strategy changes the outcome — and the valuation.</p>
            <div className="pat-benefit-items">
              {[
                { icon: "🚀", title: "Early-Stage Startups", desc: "Build IP into your fundraising story from day one. Investors pay attention to patent-pending and granted IP — it signals technical differentiation and defensibility." },
                { icon: "📈", title: "Growth-Stage Companies", desc: "As you scale into new markets and products, your IP strategy needs to scale with you. We map the competitive landscape and file offensively to stay ahead of fast followers." },
                { icon: "🏢", title: "Pre-M&A Companies", desc: "IP is frequently the most valuable asset in an acquisition. A well-organized, strategically positioned patent portfolio can significantly increase your acquisition price and deal certainty." },
                { icon: "🔬", title: "R&D-Heavy Organizations", desc: "If your competitive advantage lives in technology, your IP strategy should be as deliberate as your engineering roadmap. We align the two so every R&D investment creates protectable IP." },
              ].map((b, i) => (
                <div key={i} className="pat-benefit-item">
                  <div className="pat-benefit-icon">{b.icon}</div>
                  <div><div className="pat-benefit-title">{b.title}</div><div className="pat-benefit-desc">{b.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="pat-kicker">Our Engagement Model</div>
            <div className="pat-sub-h2">How an IP Strategy Engagement Works</div>
            <p className="pat-split-p">We run IP strategy engagements as focused 4–8 week sprints, delivering a comprehensive IP roadmap and ongoing quarterly advisory — not a one-time report that sits on a shelf.</p>
            <div className="pat-v-steps">
              {[
                { num: "01", title: "IP Discovery Audit", desc: "We inventory every innovation your company has created — patented, pending, or undisclosed — and identify the technical differentiators that form your competitive advantage." },
                { num: "02", title: "Competitive Landscape Mapping", desc: "We analyze the patent portfolios of your top 10–15 competitors, map the technology space, and identify both threats and white-space opportunities." },
                { num: "03", title: "Strategy Workshop", desc: "A half-day working session with your leadership, engineering, and product teams to pressure-test the analysis and align on strategic priorities." },
                { num: "04", title: "IP Roadmap Delivery", desc: "A written 3-year IP roadmap: which inventions to file, in what order, in which countries, with budget estimates, timelines, and expected business outcomes." },
                { num: "05", title: "Quarterly Advisory Check-Ins", desc: "Ongoing quarterly sessions to update the roadmap as your product evolves, new competitors emerge, and your business strategy shifts." },
              ].map((step, i) => (
                <div key={i} className="pat-v-step">
                  <div className="pat-v-step-left"><div className="pat-v-step-num">{step.num}</div><div className="pat-v-step-line" /></div>
                  <div><div className="pat-v-step-title">{step.title}</div><div className="pat-v-step-desc">{step.desc}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <SubCTA tag="Strategic IP Advisory" title="Stop Patenting Reactively. Start Building a Moat." body="The companies that dominate their markets don't just file patents — they build deliberate IP strategies that make it impossible for competitors to replicate their advantage. Let us build yours." primary="Build Your IP Strategy" secondary="Free Strategy Call" bullets={["Patent landscape analysis", "R&D alignment", "Investor-ready positioning", "Quarterly advisory included"]} />
  </>
);

/* ─────────────────────── Root: Routing ─────────────────────── */

const PatentServices = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const serviceSlug = (searchParams.get("service") || "").toLowerCase();

  const handleSelect = (slug: string) => {
    setSearchParams({ service: slug });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBack = () => {
    setSearchParams({});
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderContent = () => {
    switch (serviceSlug) {
      case "patent-search":        return <PatentSearchPage onBack={handleBack} />;
      case "application-drafting": return <ApplicationDraftingPage onBack={handleBack} />;
      case "patent-prosecution":   return <PatentProsecutionPage onBack={handleBack} />;
      case "international-filing": return <InternationalFilingPage onBack={handleBack} />;
      case "portfolio-management": return <PortfolioManagementPage onBack={handleBack} />;
      case "innovation-strategy":  return <InnovationStrategyPage onBack={handleBack} />;
      default:                     return <PatentServicesOverview onSelect={handleSelect} />;
    }
  };

  return (
    <div className="pat-page">
      <style>{styles}</style>
      {renderContent()}
    </div>
  );
};

export default PatentServices;
